import {FormDrawer} from "@/components/form/overlay/FormDrawer.tsx";

interface FormDrawerActionDialogProps {
  show: boolean;
  title: string;
  loading?: boolean;
  size?: "sm" | "md" | "lg";
  onCancel: () => void;
  onConfirm: () => void;
  confirmBtnText?: string;
  cancelBtnText?: string;
  hasCancelButton?: boolean;
  hasConfirmButton?: boolean;
  disableConfirmButton?: boolean;
  children: React.ReactNode;
}

export const FormDrawerActionDialog = ({
  show,
  onCancel,
  title,
  loading,
  children,
  onConfirm,
  confirmBtnText,
  cancelBtnText,
  hasCancelButton = true,
  hasConfirmButton = true,
}: FormDrawerActionDialogProps) => (
  <FormDrawer
    show={show}
    className="px-1"
    onCancel={onCancel}
    onSubmit={onConfirm}
    hasCancelButton={hasCancelButton}
    hasSubmitButton={hasConfirmButton}
    submitBtnText={confirmBtnText || "Confirm"}
    cancelBtnText={cancelBtnText || "Cancel"}
    title={title}
    loading={loading}
    placement={"end"}
  >
    {children}
  </FormDrawer>
);
